import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useUploadVariableSalaryForEmployeeMutation,
  useUploadVariableSalaryMutation,
} from "../../features/payrollSetting/payrollSettingApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import { ModalComponentProps } from "../../types";
import UploadExcelModal from "../common/UploadExcelModal";
import SuccessModal from "../Report/SuccessModal";

type Props = {
  forEmployee?: boolean;
} & ModalComponentProps;

export default function VariableSalaryModal({
  open,
  handleClose,
  forEmployee,
}: Props) {
  const navigate = useNavigate();
  const [uploadVariableSalary, { isLoading, isError, error, isSuccess }] =
    useUploadVariableSalaryMutation();
  const [
    uploadVariableSalaryForEmployee,
    {
      isLoading: isAnotherLoading,
      isError: isAnotherError,
      error: anotherError,
      isSuccess: isAnotherSuccess,
      // data: anotherData,
    },
  ] = useUploadVariableSalaryForEmployeeMutation();
  useError(isError, error, "Upload variable salary fail");
  useError(isAnotherError, anotherError, "Upload variable salary fail");
  const [formData, setFormData] = useState<FormData | null>(null);

  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  const handleUpload = () => {
    if (forEmployee) {
      uploadVariableSalaryForEmployee(formData);
    } else {
      uploadVariableSalary(formData);
    }
  };

  // success toast message
  useEffect(() => {
    if (isSuccess || isAnotherSuccess) {
      toast("success", "Variable salary updated successfully");
      // navigate("/admin/payroll/variable-salary");
      // if (
      //   data?.data?.success === "success" ||
      //   anotherData?.data?.success === "success"
      // ) {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
      handleOpen({ type: "SUCCESS" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, isAnotherSuccess, navigate]);

  return (
    <>
      <UploadExcelModal
        open={open}
        handleClose={handleClose}
        isLoading={false}
        handler={setFormData}
        title="Update Variable Salary Data in Bulk"
        warningText={
          !forEmployee
            ? "Please enter the year as a four-digit number (e.g., 2025, 2024) and the month as a number (e.g., 1 for January, 12 for December)."
            : undefined
        }
        downloadLink={
          forEmployee
            ? "/sample-variable-salary-from-employee.xlsx"
            : "/sample-variable-salary.xlsx"
        }
        footer={
          <Space size={12}>
            {childOpen?.type === "SUCCESS" && (
              <SuccessModal
                type="queue"
                open={childOpen?.open}
                handleClose={childClose}
              />
            )}
            <Button
              className="modal-button"
              type="primary"
              loading={isLoading || isAnotherLoading}
              onClick={handleUpload}
            >
              Upload
            </Button>
          </Space>
        }
      />
    </>
  );
}
